function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.433 5.518l1.989 3.977 3.826.383a.484.484 0 01.295.824l-3.153 3.152 1.169 4.283a.485.485 0 01-.684.561L12 16.76 8.125 18.7a.484.484 0 01-.683-.561l1.168-4.285L5.457 10.7a.484.484 0 01.295-.824l3.826-.383 1.989-3.977a.484.484 0 01.866.002z",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgRatingStar1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref);
}

export default SvgRatingStar1;